<template>
  <div class="app-container">
    <el-form :inline="true" ref="filterForm" :model="filter" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="资产码" v-model="filter.assetsCode" @keyup.enter.native="toFilter"></el-input>
      </el-form-item>
      <!-- <el-form-item label="三元组">
        <div @click="onSelectTriplet">
          <el-input v-model="filter.triplet_id" readonly placeholder="请选择三元组" suffix-icon="el-icon-more"></el-input>
        </div>
      </el-form-item> -->
      <el-form-item label="时间" prop="date">
        <el-date-picker v-model="filter.date" type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item label="日志类型">
        <el-input placeholder="日志类型" v-model="filter.rec_type"></el-input>
      </el-form-item>
      <el-form-item label="消息topic">
        <el-input placeholder="消息topic" v-model="filter.rec_topic"></el-input>
      </el-form-item>
      <el-form-item label="日志内容">
        <el-input placeholder="日志内容" v-model="filter.rec_json"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="toFilter" type="primary">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="创建时间" prop="create_time" width="160"></el-table-column>
      <el-table-column label="日志类型" prop="rec_type" width="90"></el-table-column>
      <el-table-column label="消息topic" prop="rec_topic" width="365"></el-table-column>
      <el-table-column label="日志内容" prop="rec_json"></el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <!-- 三元组选择框 -->
    <select-triplet :show.sync="visible.triplet" @confirm="confirmSelectTriplet" :device-type="logType"></select-triplet>
  </div>
</template>

<script>
import { GetPageListLog } from "@/api/dev_archive"
import pageMixin from "@/mixins/pageMixin.js"
import selectTriplet from "../dev_archive/components/select-triplet.vue"

export default {
  name: "RunningLog",
  mixins: [pageMixin],
  components: { selectTriplet },
  data() {
    return {
      visible: {
        triplet: false
      },
      logType: "1",
      tableData: [],
      filter: {
        assetsCode: "",
        triplet_id: "",
        rec_json: "",
        rec_topic: ""
      },
      // triplet_id: "",
      allLine: [],
      props: {
        children: "Children",
        label: "name",
        value: "ID",
        emitPath: false
      },
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  created() {
    // this.loadAllLine()
    this.getData()
  },
  methods: {
    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },

    confirmSelectTriplet(item) {
      this.visible.triplet = false
      this.filter.triplet_id = item.ID
    },
    onSelectTriplet() {
      this.visible.triplet = true
      this.filter.triplet_id = ""
    },
    getData() {
      let startTime = "",
        endTime = ""
      this.loading = true
      if (this.filter.date && this.filter.date.length) {
        startTime = this.filter.date[0]
        endTime = this.filter.date[1]
      }
      GetPageListLog({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        triplet_id: this.filter.triplet_id,
        assetsCode: this.filter.assetsCode,
        rec_topic: this.filter.rec_topic,
        rec_type: this.filter.rec_type,
        rec_json: this.filter.rec_json,
        start_time: startTime,
        end_time: endTime
      })
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleData(data) {
      data.forEach((item) => {
        if (item.Children && item.Children.length) {
          this.handleData(item.Children)
        } else {
          item.level === 2 && delete item.Children
        }
      })
      return data
    },
    loadAllLine() {
      getAllLineTree().then((res) => {
        this.allLine = this.handleData(res.data)
      })
    },
    onexport() {
      let startTime = "",
        endTime = ""
      if (this.filter.date && this.filter.date.length) {
        startTime = this.filter.date[0]
        endTime = this.filter.date[1]
      }
      this.loading = true
      emportDeviceLogLs({
        arid: this.filter.lineName || "",
        begintime: startTime,
        endtime: endTime,
        status: this.filter.deviceStatus || 0
      })
        .then((res) => {
          this.$message.success(`${this.$t("publics.emportsuccessmsg")}`)
          // 然后就可以创建a标签 最后下载下来了
          let link = document.createElement("a")
          // 不显示链接
          link.style.display = "none"
          link.href = res.outputData.FilePath
          // 设置链接属性
          link.setAttribute("download", res.outputData.FileName)
          //点击链接
          document.body.appendChild(link)
          link.click()
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.el-cascader-menu {
  max-width: 250px;
}
</style>
